import { Badge } from '@mantine/core'
import { LoomWoolLotOfferStatus } from '@shared/components/offers/offer-types'
import { IconCheck, IconX } from '@tabler/icons-react'

type OfferFormDecisionBadgeProps = {
  status: LoomWoolLotOfferStatus
  index: number
}

export function OfferFormDecisionBadge({ status, index }: OfferFormDecisionBadgeProps) {
  if (status === LoomWoolLotOfferStatus.Accepted) {
    return (
      <Badge
        color='green'
        c='green.7'
        size='lg'
        variant='light'
        fw={600}
        leftSection={<IconCheck />}
        aria-label={`Wool lot ${index + 1} offer accepted`}
      >
        Offer Accepted
      </Badge>
    )
  }
  if (status === LoomWoolLotOfferStatus.Declined) {
    return (
      <Badge
        color='red'
        size='lg'
        variant='light'
        fw={600}
        leftSection={<IconX />}
        aria-label={`Wool lot ${index + 1} offer declined`}
      >
        Offer Declined
      </Badge>
    )
  }
}
